<h4><strong>Upload Documents</strong></h4>
<p-dataView #dv [value]="modelForDataview" [rows]="props.listOptions.rowsPerPage"
  [rowsPerPageOptions]="props.listOptions.rowsPerPageOptions" [paginator]="props.listOptions.paginator"
  [emptyMessage]="emptyMessageText">
  <ng-template *ngIf="props.listOptions.allowUpload" pTemplate="header">
    <ng-container *ngIf="props.listOptions.allowUpload">
      <p-fileUpload #fileUploader name="demo[]" url="./upload.php" [accept]="acceptedFileTypes"
        (onUpload)="uploadFiles($event)" [customUpload]="true"
        [invalidFileTypeMessageDetail]="invalidFileTypeMessageDetail" [maxFileSize]="maxFileSize"
        [fileLimit]="fileLimit" [multiple]="!props.listOptions.enableTitle"
        (onSelect)="uploadFiles($event)" [showUploadButton]="false" [showCancelButton]="false" [auto]="auto"
        [disabled]="fileLimit && modelForDataview?.length >= fileLimit"
        [validateFileSize]="validateFileSize.bind(this)"
        [invalidFileSizeMessageDetail]="invalidFileSizeMessageDetail"
        [invalidFileSizeMessageSummary]="invalidFileSizeMessageSummary"
        [useFileAcceptAttribute]="props.fileUploadOptions.useFileAcceptAttribute"
        [uploadedFiles]="modelForDataview"
        class="w-full">
        <ng-template pTemplate="content">
          <div *ngIf="props.listOptions.enableTitle" class="flex flex-column gap-2">
            <form [formGroup]="titleForm">
              <formly-form [model]="title" [fields]="titleFormFields" [options]="titleOptions"
                [form]="titleForm"></formly-form>
            </form>
          </div>
          <div class="w-full py-3" [style.cursor]="fileLimit && modelForDataview?.length >= fileLimit ? 'not-allowed' : 'copy'" (click)="fileUploader.advancedFileInput.nativeElement.click()" (keydown.enter)="fileUploader.advancedFileInput.nativeElement.click()" tabindex="0">
            <div class="h-full flex flex-column justify-content-center align-items-center" [ngClass]="{'file-limit-error': fileLimit && modelForDataview?.length >= fileLimit}">
              <i role="img" aria-label="Opens upload document dialog" *ngIf="fileLimit && modelForDataview?.length < fileLimit" class="pi pi-upload text-900 text-2xl mb-3"></i>
              <span class="font-bold text-900 text-xl mb-3">{{fileLimit && modelForDataview?.length >= fileLimit ? 'Upload Limit Reached' : uploadText}}</span>
              <span class="font-medium text-600 text-md text-center">{{fileLimit && modelForDataview?.length >= fileLimit ? 'Delete files to continue uploading' : dropFileText}}</span>
            </div>
          </div>
          <!-- <p-button id="workSheetUploadButton"
            type="button"
            label="Add"
            (click)="onWorkSheetUpload()">
          </p-button> -->
        </ng-template>
      </p-fileUpload>
    </ng-container>
    <div class="clearfix"></div>
  </ng-template>
  <ng-template *ngIf="!props.listOptions.isCompactMode" let-files pTemplate="list">
    <ng-container *ngIf="props.listOptions.documentListFileUploadText || props.listOptions.showAvailableUploads">
      <div class="section file-upload-info">
          <ng-container *ngIf="props.listOptions.documentListFileUploadText">
            <div [innerHTML]="props.listOptions.documentListFileUploadText"></div>
          </ng-container>
          <ng-container *ngIf="props.listOptions.documentListFileUploadText && fileLimit">
            <p>You can upload up to {{fileLimit}} files in total.</p>
          </ng-container>
      </div>
    </ng-container>
    <div *ngFor="let file of files; trackBy: trackFileList" class="message vptas-message">
      <div class="col-12 vptas-message-inner-container" [ngClass]="{'sm:col-8 md:col-9 lg:col-10 xl:col-11': props.fileUploadOptions?.displayThumbnails,
                                      'md:col-12 lg:col-12': !props.fileUploadOptions?.displayThumbnails}">
        <p-avatar [image]="getFilePreviewUrl(file)" [icon]="!getFilePreviewUrl(file) ? getDocumentIcon(file) : ''" 
                  size="large" class="messager-img avatar-image"></p-avatar>
        <div class="messager">
          Name: {{ file.name }}
          <ng-container *ngIf="file.documentNumber">
            , Number: {{ file.documentNumber }}
          </ng-container>
          <ng-container *ngIf="file.documentDate">
            , Date: {{ file.documentDate }}
          </ng-container>
            , Amount: {{ file.documentAmount }}
          <br />
          <span *ngIf="file.createdDate || file.createdBy" class="date pull-right vptas-message-additional-details">
            {{file.createdBy}} {{file.createdDate && file.createdBy ? ' - ' : '' }}
            {{file.createdDate | date: longDate}} ({{file.name}})</span>
        </div>
      </div>
      <div class="message-text">{{file.shortMessage}}
          <ng-container *ngIf="isImageOrVideoFile(file)">
            <!--Assuming whoever can view or download can view the image/video -->
            <button *ngIf="(file.canView  || file.canDownload) && !isMpegFile(file)" [title]="getActionButtonTitle('View',file)" pButton pRipple type="button"
              class="p-button-rounded p-button-text pull-right" icon="pi pi-eye"
              (click)="viewImageButtonClicked(file)"></button>
          </ng-container>
          <ng-container *ngIf="!isImageOrVideoFile(file)">
            <!--Assuming whoever can view or download can view the file -->
            <button *ngIf="(file.canView  || file.canDownload)" [title]="getActionButtonTitle('View',file)" pButton pRipple type="button"
              class="p-button-rounded p-button-text pull-right" icon="pi pi-eye"
              (click)="viewButtonClicked(file)"></button>
          </ng-container>
          <button *ngIf="file.canDownload" [title]="getActionButtonTitle('Download',file)" pButton pRipple type="button"
            class="p-button-rounded p-button-text pull-right" icon="pi pi-download"
            (click)="downloadButtonClicked(file)"></button>
          <button *ngIf="file.canDelete" [title]="getActionButtonTitle('Delete',file)" pButton pRipple type="button"
            class="p-button-rounded p-button-text pull-right" icon="pi pi-trash"
            (click)="removeButtonClicked(file)"></button>
          <ng-container *ngFor="let actionButton of props.actionButtons">
            <button *ngIf=isActionButtonVisible(file,actionButton) pButton pRipple type="button"
              [title]="getActionButtonTitle(actionButton.label,file)" [disabled]="isReadonly()"
              class="p-button-rounded p-button-text pull-right" [icon]="actionButton.icon"
              (click)="actionButtonClicked(actionButton.type, file)"></button>
          </ng-container>
      </div>
    </div>
    <div class="clearfix"></div>
  </ng-template>

  <ng-template *ngIf="props.listOptions.isCompactMode" let-files pTemplate="list">
    <div *ngFor="let file of files; trackBy: trackFileList" class="message border-1 mb-3 compact">
      <p-avatar [image]="getFilePreviewUrl(file)" [icon]="getDocumentIcon(file)" size="large" class="messager-img"></p-avatar>
      <div class="messager">{{file.name}}</div>
      <div *ngIf="file.createdDate" class="message-text">
        {{file.createdDate | date: longDate}}
      </div>
      <div class="message-text">
        <ng-container *ngIf="!isImageOrVideoFile(file)">
          <button *ngIf="file.canView" [title]="getActionButtonTitle('View',file)" pButton pRipple type="button"
            class="p-button-rounded p-button-text" icon="pi pi-eye" (click)="viewButtonClicked(file)"></button>
        </ng-container>
        <button *ngIf="file.canDownload" [title]="getActionButtonTitle('Download',file)" pButton pRipple type="button"
          class="p-button-rounded p-button-text" icon="pi pi-download" (click)="downloadButtonClicked(file)"></button>
        <button *ngIf="file.canDelete" [title]="getActionButtonTitle('Delete',file)" pButton pRipple type="button"
          class="p-button-rounded p-button-text" icon="pi pi-trash" (click)="removeButtonClicked(file)"></button>
        <ng-container *ngFor="let actionButton of props.actionButtons">
          <button *ngIf=isActionButtonVisible(file,actionButton) pButton pRipple type="button"
            [title]="getActionButtonTitle(actionButton.label,file)" [disabled]="isReadonly()"
            class="p-button-rounded p-button-text" [icon]="actionButton.icon"
            (click)="actionButtonClicked(actionButton.type, file)"></button>
        </ng-container>
      </div>
    </div>
    <div class="clearfix"></div>
  </ng-template>
  <ng-template #emptyListTemplate>
    <div class="message-box">
      <div class="messager">No documents found.</div>
    </div>
  </ng-template>
</p-dataView>